import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import update from 'immutability-helper';
import InvoiceHeader from './InvoiceHeader';
import LineItems from './LineItems';
import { postRequest, putRequest, deleteRequest } from '../../requestUtils';
import { analyticsTrack } from '../../analyticsUtils';
import { sum, sumTime } from '../../arrayUtils';
import { formatDateForApi } from '../../dateUtils';
import './Invoice.scss';
var Invoice = /*#__PURE__*/function (_Component) {
  function Invoice(props) {
    var _this;
    _classCallCheck(this, Invoice);
    _this = _callSuper(this, Invoice, [props]);
    var invoice = props.invoice;
    _this.state = {
      consulting: invoice.line_items.consulting || [],
      travel: invoice.line_items.travel || [],
      expense: invoice.line_items.expense || [],
      updated: false
    };
    _this.getDate = _this.getDate.bind(_this);
    _this.handleNewLineItem = _this.handleNewLineItem.bind(_this);
    _this.handleUpdateLineItem = _this.handleUpdateLineItem.bind(_this);
    _this.handleDeleteLineItem = _this.handleDeleteLineItem.bind(_this);
    _this.handleUploadFile = _this.handleUploadFile.bind(_this);
    return _this;
  }
  _inherits(Invoice, _Component);
  return _createClass(Invoice, [{
    key: "getDate",
    value: function getDate() {
      var end_date = this.props.invoice.end_date;
      var thisMonth = moment().format('M');
      var thatMonth = moment(end_date).format('M');
      return thisMonth !== thatMonth ? moment(end_date).toDate() : new Date();
    }
  }, {
    key: "handleNewLineItem",
    value: function handleNewLineItem(category) {
      var _this2 = this;
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        invoice = _this$props.invoice;
      this.setState({
        updated: false
      });
      postRequest("/invoices/".concat(invoice.resource_id, "/line_items"), {
        // getDate() returns a raw Date (moment(end_date).toDate() or new Date()) — format at
        // this API boundary so JSON.stringify never converts it to UTC and shifts the day.
        line_item: {
          category: category,
          date: formatDateForApi(this.getDate())
        }
      }, csrfToken).then(function (response) {
        _this2.setState(_defineProperty(_defineProperty({}, category, update(_this2.state[category], {
          $push: [response.data]
        })), "updated", true));
      });
    }
  }, {
    key: "handleUpdateLineItem",
    value: function handleUpdateLineItem(id, data) {
      var _this3 = this;
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        invoice = _this$props2.invoice;
      this.setState({
        updated: false
      });
      putRequest("/invoices/".concat(invoice.resource_id, "/line_items/").concat(id), {
        line_item: data
      }, csrfToken).then(function (response) {
        var item = response.data;
        _this3.setState(_defineProperty(_defineProperty({}, item.category, _this3.state[item.category].map(function (el) {
          return el.id === item.id ? item : el;
        })), "updated", true));
      });
    }
  }, {
    key: "handleDeleteLineItem",
    value: function handleDeleteLineItem(id, category) {
      var _this4 = this;
      var _this$props3 = this.props,
        csrfToken = _this$props3.csrfToken,
        invoice = _this$props3.invoice,
        location = _this$props3.location;
      this.setState({
        updated: false
      });
      deleteRequest("/invoices/".concat(invoice.resource_id, "/line_items/").concat(id), csrfToken).then(function () {
        analyticsTrack('Delete line item', {
          location: location
        });
        _this4.setState(_defineProperty(_defineProperty({}, category, _this4.state[category].filter(function (el) {
          return el.id !== id;
        })), "updated", true));
      });
    }
  }, {
    key: "handleUploadFile",
    value: function handleUploadFile(id, file) {
      if (file !== null && file !== void 0 && file.category) {
        this.setState(_defineProperty(_defineProperty({}, file.category, this.state[file.category].map(function (el) {
          return el.id === file.id ? file : el;
        })), "updated", true));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        projectName = _this$props4.projectName,
        projectResourceId = _this$props4.projectResourceId,
        invoice = _this$props4.invoice,
        company = _this$props4.company,
        csrfToken = _this$props4.csrfToken,
        location = _this$props4.location,
        workCommitment = _this$props4.workCommitment,
        areaOfExpertises = _this$props4.areaOfExpertises,
        tags = _this$props4.tags,
        jobTitles = _this$props4.jobTitles,
        description = _this$props4.description,
        responsibilities = _this$props4.responsibilities,
        duration = _this$props4.duration,
        workLocation = _this$props4.workLocation,
        shortOfficeLocation = _this$props4.shortOfficeLocation,
        startDate = _this$props4.startDate,
        showHourWarning = _this$props4.showHourWarning;
      var _this$state = this.state,
        consulting = _this$state.consulting,
        travel = _this$state.travel,
        expense = _this$state.expense,
        updated = _this$state.updated;
      return /*#__PURE__*/React.createElement("div", {
        className: "invoice"
      }, /*#__PURE__*/React.createElement("div", {
        className: "width-1200"
      }, /*#__PURE__*/React.createElement(InvoiceHeader, {
        invoiceNumber: invoice.invoice_number,
        id: invoice.resource_id,
        abbreviatedMonth: invoice.abbreviated_month,
        month: invoice.month,
        year: invoice.year,
        status: invoice.status,
        statusDisplay: invoice.status_display,
        projectResourceId: projectResourceId,
        projectName: projectName,
        consultantName: invoice.consultant_name,
        consultantDueDate: invoice.due_date,
        memo: invoice.memo,
        projectedHours: invoice.projected_hours_by_consultants,
        totals: {
          consulting: sum(consulting),
          travel: sum(travel),
          expense: sum(expense),
          total: sum(consulting) + sum(travel) + sum(expense)
        },
        totalHours: sumTime(consulting).hours + sumTime(travel).hours,
        totalMinutes: sumTime(consulting).minutes + sumTime(travel).minutes,
        hourLimit: invoice.hour_limit,
        company: company,
        csrfToken: csrfToken,
        statusChangeDate: invoice.status_change,
        location: location,
        feedback: invoice.feedback,
        updated: updated,
        editsRequestedBy: invoice.edits_requested_by,
        editsRequestedOn: invoice.edits_requested_on,
        approvedBy: invoice.approved_by,
        approvedOn: invoice.approved_on,
        workCommitment: workCommitment,
        areaOfExpertises: areaOfExpertises,
        tags: tags,
        jobTitles: jobTitles,
        description: description,
        responsibilities: responsibilities,
        duration: duration,
        workLocation: workLocation,
        shortOfficeLocation: shortOfficeLocation,
        startDate: startDate,
        buttonStyles: "body-text-1",
        showHourWarning: showHourWarning
      }), /*#__PURE__*/React.createElement(LineItems, {
        invoiceId: invoice.resource_id,
        lineItems: consulting,
        lineItemsGroupName: "Consulting Hours - $".concat(invoice.labor_rate, "/hr"),
        descriptionLabel: "Task Description",
        category: "consulting",
        hasDuration: true,
        rate: invoice.labor_rate,
        startDate: invoice.start_date,
        endDate: invoice.end_date,
        handleNewLineItem: this.handleNewLineItem,
        handleUpdateLineItem: this.handleUpdateLineItem,
        handleDeleteLineItem: this.handleDeleteLineItem,
        totalPay: sum(consulting),
        totalTime: sumTime(consulting),
        status: invoice.status
      }), /*#__PURE__*/React.createElement(LineItems, {
        invoiceId: invoice.resource_id,
        lineItems: travel,
        lineItemsGroupName: "Travel Hours - $".concat(invoice.travel_rate, "/hr"),
        descriptionLabel: "Travel Description",
        category: "travel",
        hasDuration: true,
        rate: invoice.travel_rate,
        startDate: invoice.start_date,
        endDate: invoice.end_date,
        handleNewLineItem: this.handleNewLineItem,
        handleUpdateLineItem: this.handleUpdateLineItem,
        handleDeleteLineItem: this.handleDeleteLineItem,
        totalPay: sum(travel),
        totalTime: sumTime(travel),
        status: invoice.status
      }), /*#__PURE__*/React.createElement(LineItems, {
        invoiceId: invoice.resource_id,
        lineItems: expense,
        lineItemsGroupName: "Expenses",
        descriptionLabel: "Expense Description",
        category: "expense",
        startDate: invoice.start_date,
        endDate: invoice.end_date,
        handleNewLineItem: this.handleNewLineItem,
        handleUpdateLineItem: this.handleUpdateLineItem,
        handleDeleteLineItem: this.handleDeleteLineItem,
        handleUploadFile: this.handleUploadFile,
        totalPay: sum(expense),
        csrfToken: csrfToken,
        status: invoice.status
      })));
    }
  }]);
}(Component);
Invoice.propTypes = {
  invoice: PropTypes.shape({}).isRequired,
  projectName: PropTypes.string.isRequired,
  projectResourceId: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  workCommitment: PropTypes.number.isRequired,
  areaOfExpertises: PropTypes.arrayOf(PropTypes.string),
  tags: PropTypes.arrayOf(PropTypes.string),
  jobTitles: PropTypes.string,
  description: PropTypes.string.isRequired,
  responsibilities: PropTypes.arrayOf(PropTypes.string).isRequired,
  duration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  workLocation: PropTypes.string.isRequired,
  shortOfficeLocation: PropTypes.string.isRequired,
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  showHourWarning: PropTypes.bool
};
Invoice.defaultProps = {
  areaOfExpertises: [],
  tags: [],
  jobTitles: '',
  startDate: null,
  showHourWarning: false
};
export default Invoice;